import { BoldMatch } from './BoldMatch';

export default BoldMatch;

export { BoldMatch };
